<template>
  <div class="tes-card pa-7 fill-weight">
    <h1 class="tes-card__title">Квитанция об оплате</h1>

    <v-row no-gutters class="my-4">
      <v-col cols="9">
        <div class="d-flex flex-nowrap">
          <span class="helvetica-medium mr-3 fs-18 d-inline-block mt-1">Лицевой&nbsp;счёт:</span>
          <personal-account-select class="d-inline-block" :disabled="true"></personal-account-select>
        </div>
      </v-col>
      <div class="flex-grow-1"></div>
      <v-col cols="3" class="text-right tes-green-text helvetica-medium fs-20">
        <div>Январь 2019</div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    layout: 'main',
    data:() => ({
      id: null
    }),
    computed: {
      payment() {
        return this.$store.getters['payments/getHistoryPaymentById'](this.id);
      }
    },
    created() {
      this.id = this.$route.params
    }
  }
</script>

<style scoped>

</style>
